import React, { Component } from 'react';
import PropTypes from "prop-types";

import Circle from "./../../Circle";

export const TableItem = ({data}) => {
    return (
        <td className="appointment_table__item">
        <div className="appointment_table__item__container">
            <span className="appointment_table__item__head">
                <p>{data.timeStart}</p>
                {data.isActive ? <Circle time={data.timeStart} date={data.date}/> : null}
            </span>
            {data.isActive ? <p>Талонов: {data.ticket}</p> : <p style={{textAlign: "center"}}>Запись завершена</p>}
        </div>
    </td>
    )
}

TableItem.propTypes = {
    data: PropTypes.object.isRequired
};

export default TableItem;



// WEBPACK FOOTER //
// frontend/src/modules/appointment-table/row/item/index.jsx